import { RequiredInfoError } from '@/ui/features/background-check/components/background-check-modal/components/RequiredInfoError';
import { AccountData } from '@juvare/contact-management/backend/features/accounts/shared';
import { TableCell, TableRow } from '@mui/material';
import get from 'lodash/get';
import React from 'react';

interface AccountDetailsTableRowProps {
    account: AccountData;
    error: string;
    label: string;
    path: string;
}

export const AccountDetailsTableRow: React.FC<AccountDetailsTableRowProps> = ({ path, label, account, error }) => (
    <TableRow key={path}>
        <TableCell sx={{ borderBottom: 'unset', width: 1 / 2 }}>{label}</TableCell>
        <TableCell sx={{ borderBottom: 'unset', width: 1 / 2, fontWeight: 500 }}>
            {get(account, path)}
            {error && <RequiredInfoError label={error} />}
        </TableCell>
    </TableRow>
);
